export default "__VITE_ASSET__DPKM1RYJ__"